module.exports = __webpack_public_path__ + "fonts/Raleway-ExtraLight.3d22c4cb.ttf";